import axios from '@/libs/api.request'

export const getProject = (projectId) => {
  return axios.request({
    method: 'GET',
    url: `integration/basecamp/projects/${projectId}`
  })
}
